/* Skarpast – offertkorg (quote cart). Lagras i localStorage, separat från Shopify-kassan. */
(function () {
  var KEY = 'sk_quote_cart';

  function read() {
    try {
      return JSON.parse(window.localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(items) {
    window.localStorage.setItem(KEY, JSON.stringify(items));
    updateCount();
  }
  function updateCount() {
    var count = read().reduce(function (sum, item) { return sum + item.quantity; }, 0);
    document.querySelectorAll('[data-sk-quote-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function variantTitle(button) {
    var script = button.parentElement
      ? button.parentElement.querySelector('script[data-sk-quote-variants]')
      : null;
    if (!script) return { id: null, title: '', sku: '' };
    try {
      var variants = JSON.parse(script.textContent);
      var select = document.querySelector('form[action*="/cart/add"] select[name="id"], product-form-component select[name="id"]');
      var selectedId = select ? parseInt(select.value, 10) : null;
      var found = variants.find(function (v) { return v.id === selectedId; }) || variants[0];
      return found || { id: null, title: '', sku: '' };
    } catch (e) {
      return { id: null, title: '', sku: '' };
    }
  }

  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-sk-quote-add]');
    if (addBtn) {
      var variant = variantTitle(addBtn);
      var items = read();
      var existing = items.find(function (item) {
        return item.handle === addBtn.dataset.productHandle && item.variantId === variant.id;
      });
      if (existing) {
        existing.quantity += 1;
      } else {
        items.push({
          handle: addBtn.dataset.productHandle,
          title: addBtn.dataset.productTitle,
          url: addBtn.dataset.productUrl,
          image: addBtn.dataset.productImage,
          variantId: variant.id,
          variantTitle: variant.title,
          sku: variant.sku,
          quantity: 1
        });
      }
      write(items);
      var original = addBtn.textContent;
      addBtn.textContent = '✓';
      setTimeout(function () { addBtn.textContent = original; }, 1200);
      return;
    }

    var qtyBtn = event.target.closest('[data-sk-quote-qty]');
    if (qtyBtn) {
      var items2 = read();
      var idx = parseInt(qtyBtn.dataset.skQuoteQty, 10);
      var delta = parseInt(qtyBtn.dataset.delta, 10);
      if (items2[idx]) {
        items2[idx].quantity = Math.max(1, items2[idx].quantity + delta);
        write(items2);
        renderList();
      }
      return;
    }

    var removeBtn = event.target.closest('[data-sk-quote-remove]');
    if (removeBtn) {
      var items3 = read();
      items3.splice(parseInt(removeBtn.dataset.skQuoteRemove, 10), 1);
      write(items3);
      renderList();
    }
  });

  function renderList() {
    var list = document.querySelector('[data-sk-quote-items]');
    if (!list) return;
    var items = read();
    var layout = document.querySelector('[data-sk-quote-layout]');
    var empty = document.querySelector('[data-sk-quote-empty]');

    if (items.length === 0) {
      if (layout) layout.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (layout) layout.hidden = false;
    if (empty) empty.hidden = true;

    list.innerHTML = items.map(function (item, i) {
      return (
        '<li class="sk-quote-cart__item">' +
        (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') +
        '<div class="sk-quote-cart__item-info">' +
        '<p class="sk-quote-cart__item-title"><a href="' + item.url + '">' + item.title + '</a></p>' +
        (item.variantTitle && item.variantTitle !== 'Default Title'
          ? '<p class="sk-quote-cart__item-variant">' + item.variantTitle + (item.sku ? ' · art. ' + item.sku : '') + '</p>'
          : '') +
        '<button type="button" class="sk-quote-cart__remove" data-sk-quote-remove="' + i + '">Ta bort</button>' +
        '</div>' +
        '<div class="sk-quote-cart__item-qty">' +
        '<button type="button" data-sk-quote-qty="' + i + '" data-delta="-1">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-sk-quote-qty="' + i + '" data-delta="1">+</button>' +
        '</div>' +
        '</li>'
      );
    }).join('');

    var field = document.querySelector('[data-sk-quote-field]');
    if (field) {
      field.value = items.map(function (item) {
        return item.quantity + ' × ' + item.title +
          (item.variantTitle && item.variantTitle !== 'Default Title' ? ' (' + item.variantTitle + ')' : '') +
          (item.sku ? ' [art. ' + item.sku + ']' : '');
      }).join('\n');
    }
  }

  /* Töm listan efter lyckad inlämning */
  if (document.querySelector('[data-sk-quote-success]')) {
    window.localStorage.removeItem(KEY);
  }

  updateCount();
  renderList();
})();
